const config = {
  basename: '',
  stripeRedirectUri: '/stripe-connect',
  roles: {
    presenter: 'presenter',
    donor: 'donor',
    subscriber: 'subscriber',
    business: 'business',
    admin: 'platform_admin',
  },
  organizationAdmin: 'OrganizationAdmin',
  actions: {
    read: 'read',
    edit: 'edit',
    anything: 'anything',
    everything: 'everything',
  },
  components: {
    fundraiser: 'Fundraiser',
    event: 'Event',
    program: 'Program',
    service: 'Service',
    volunteer: 'Volunteer',
    auction: 'Auction',
    rental: 'Rental',
    marketplace: 'Marketplace',
    organizationDashboard: 'OrganizationDashboard',
    organizationDetails: 'OrganizationDetails',
    organizationSubscription: 'OrganizationSubscription',
    organizationPayment: 'OrganizationPayment',
    organizationReport: 'OrganizationReport',
    organizationBusinessRequests: 'OrganizationBusinessRequests',
    organizationB2BProgram: 'OrganizationB2BProgram',
    organizationCommunity: 'OrganizationCommunity',
    volunteerOpportunities: 'VolunteerOpportunities',
  },
  colors: {
    primary: '#14B1E0',
    secondary: '#0D7797',
    tertiary: '#EEEEEE',
    blue: {
      100: '#14B1E0',
    },
    gray: {
      100: '#EEEEEE',
    },
  },
  social_urls: {
    facebook: 'https://www.facebook.com/PledgeGarden/',
    instagram: 'https://www.instagram.com/PledgeGardenUSA/',
    twitter: 'https://twitter.com/PledgeGarden',
    linkledin: 'https://linkledin.com',
  },
  rowsPerPage: 6,
  itemFirstLoad: 12,
  itemPerLoad: 3,
  reportItemFirstLoad: 8,
  itemCompleteMessage: 'Yay! You have seen it all',
  splash_screen_seconds: 3,
  processing_fee_percentage: 2.5,
  defaultErrorMessage: 'Something went wrong',
  defaultSuccessMessage: 'Success',
  defaultRedirect: {
    donor: '/settings/account',
    subscriber: '/home',
    subscriberWithoutOrganizationRole: '/settings/account',
    admin: '/organizations',
  },
  imageMaxSizeLimitInKb: 5120,
  imageMaxSizeLimitErrorMessage: 'Image must be smaller than 5MB',
  getHelpUrl: 'https://dev.trustmarq.com/extensia/get-help/',
}

export default config
